import React, { PureComponent } from 'react'
import { Spin, Button, Form, Select, Row, Col, Input, DatePicker, message, Upload, Modal, Table, Icon, InputNumber } from 'antd'
import moment from 'moment'
import { advertList, saveAdvert, advertDetail, getGoodsTopic } from '_src/api/api'
import './style.less'
import { UploadIMGToOss } from '_src/utils/base'
import PrevImg from '_src/components/PrevImg/PrevImg'

const { Search } = Input
const { TextArea } = Input
const { RangePicker } = DatePicker
const { Option } = Select

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">图片上传</div>
  </div>
)

const now = moment().format('YYYYMMDD')
const getStatue = (start, end) => {
  const start_time = moment(start).format('YYYYMMDD')
  const end_time = moment(end).format('YYYYMMDD')
  // 已过期
  if (end_time < now) {
    return <div className='end-date'>已过期</div>
    // 使用中
  } else if (start_time <= now && end >= now) {
    return <div className='now-date' style={{ color: '#1890ff' }}><Icon type="check-circle" theme="twoTone" /> 使用中</div>
    // 等待使用
  } else {
    return <div className='now-date'>等待使用</div>
  }
}

@Form.create({ name: '' })
class Advert extends PureComponent {
  constructor() {
    super()
    this.state = {
      fileList: [],
      isLoading: true,
      params: {
        pageNum: 0,
        pageSize: 10,
      },
      pageData: {
        total: 0,
        current: 1,
      },
      goodsTopic: [],
      list: [],
      columns: [
        {
          title: <span>序号</span>,
          align: 'center',
          dataIndex: 'id',
          key: 'id',
        },
        {
          title: <span>广告名称</span>,
          align: 'center',
          dataIndex: 'remark',
        },
        {
          title: <span>图片</span>,
          align: 'center',
          dataIndex: 'photo',
          render: item => <img src={item} style={{ width: 100 }} alt='' onClick={() => this.PrevImg.show(item)} />
        },
        {
          title: <span>排序位置</span>,
          align: 'center',
          dataIndex: 'position',
        },
        {
          title: <span>生效时间</span>,
          align: 'center',
          render: item => <div>{moment(item.validAt).format('YYYY-MM-DD') + ' 至 ' + moment(item.expireAt).format('YYYY-MM-DD')}</div>
        },
        {
          title: <span>显示状态</span>,
          align: 'center',
          render: item => getStatue(item.validAt, item.expireAt)
        },
        {
          title: <span>操作</span>,
          align: 'center',
          render: item => <div>
            <Button icon="form" onClick={() => { this.onEdit(item.id) }} style={{ marginRight: 10 }}>编辑</Button>
            <Button icon="to-top" onClick={() => { this.toTop(item.id) }} style={{ marginRight: 10 }}>置顶</Button>
          </div>,
        },
      ]
    }
  }
  componentDidMount() {
    const { params } = this.state
    this.loadList(params)
  }

  loadList(params) {
    this.setState({ isLoading: true })
    getGoodsTopic().then({ pageSize: -1 }).then(res => {
      this.setState({
        goodsTopic: res.data.content
      })
    }).catch(e => {
      console.log(e)
    })
    advertList(params)
      .then(res => {
        res.data.content.forEach(item => {
          const expireAt = new Date(item.expireAt.replace(/-/g, '/'))
          expireAt.setDate(expireAt.getDate() - 1)
          item.expireAt = expireAt
        })
        this.setState({
          list: res.data.content,
          isLoading: false,
          pageData: {
            current: res.data.pageable.pageNumber + 1,
            total: res.data.totalElements,
            pageSize: res.data.pageable.pageSize,
          },
        })
      })
      .catch(err => {
        this.setState({
          list: [],
          isLoading: false,
          pageData: {
            current: 0,
            total: 0,
            pageSize: 0,
          },
        })
      })
  }

  // 分页
  onPageChange = (e) => {
    const { params } = this.state
    params.pageNum = e.current - 1
    this.loadList(params)
  }

  // 搜索标题
  commonChange = (value, key) => {
    const { params } = this.state
    params.pageNum = 0
    if (value) {
      params[key] = value
    } else {
      delete params[key]
    }
    this.loadList(params)
  }

  // 查看详情
  onEdit = (id) => {
    advertDetail({ id })
      .then(res => {
        const item = res.data
        const expireAt = new Date(item.expireAt.replace(/-/g, '/'))
        expireAt.setDate(expireAt.getDate() - 1)
        item.expireAt = expireAt
        const fileList = item.photo ? [{ uid: 0, name: 'xxx.png', status: 'done', url: item.photo }] : []
        this.setState({
          visible: true,
          info: res.data,
          photo: item.photo,
          fileList,
        })
      })
  }

  toTop = (id) => {
    const _this = this
    Modal.confirm({
      title: '置顶提示',
      content: '确定置顶该广告?',
      onOk() {
        advertDetail({ id })
          .then(res => {
            const item = res.data
            item.position = 1
            const hide = message.loading('保存中', 0)
            saveAdvert(item, id)
              .then(res => {
                hide()
                message.success('添加成功！', 1.2, () => {
                  const { params } = _this.state
                  _this.loadList(params)
                })
              })
          })
      },
      onCancel() {
        console.log('Cancel')
      },
    })
  }

  // 添加广告
  add = () => {
    this.setState({ visible: true })
  }

  // 广告图
  handleChange = ({ fileList }) => {
    this.setState({ fileList, upload: true })
  }

  // 预览图片
  handlePreview = (e) => {
    this.PrevImg.show(e.thumbUrl || e.url)
  }

  // 提交创建详情
  handleSubmit = (e) => {
    e.preventDefault()
    this.props.form.validateFields((err, values) => {
      if(!values.link){
        values.link = 0
      }
      if (!err) {
        const pattern = /^((https|http|ftp|rtsp|mms)?:\/\/)[^\s]+/
        if (values.link!=0 && (!values.link || (!pattern.test(values.link) && values.jumpType === 1))) {
          message.error('广告链接地址不正确', 1.5)
          return
        }
        const params = {
          remark: values.remark,
          link: values.link,
          position: values.position,
          jumpType: values.jumpType,
          module: values.module
        }
        const expireAt = new Date(values.timer[1])
        expireAt.setDate(expireAt.getDate() + 1)
        params.validAt = moment(values.timer[0]).format('YYYY-MM-DD 00:00:00')
        params.expireAt = moment(expireAt).format('YYYY-MM-DD 00:00:00')
        // 处理图片
        const { fileList, photo, upload, info } = this.state
        const hide = message.loading('添加广告中', 0)
        const advertPr = new Promise((resolve, reject) => {
          if (upload && fileList.length) {
            // 图片需要上传
            UploadIMGToOss(fileList[0])
              .then((data) => {
                if (data) {
                  resolve(data)
                } else {
                  message.error('图片上传失败！', 1.5)
                }
              })
              .catch(function (err) {
                reject(err)
                message.error('图片上传失败！', 1.5)
              })
          } else if (photo) {
            resolve(photo)
          } else {
            reject(err)
            message.info('请上传兴趣图标')
          }
        })
        advertPr.then(res => {
          params.photo = res
          const id = info ? info.id : ''
          saveAdvert(params, id)
            .then(res => {
              hide()
              const _this = this
              this.setState({
                visible: false,
                upload: false,
                photo: '',
                fileList: [],
              })
              message.success('添加成功！', 1.2, () => {
                const { params } = _this.state
                _this.loadList(params)
              })
            })
        })
      }
    })
  }
  renderGoodTopic = () => {
    return this.state.goodsTopic.map((value, index) => {
      return <Option key={index} value={value.id}>{value.name}</Option>
    })
  }
  render() {
    const { fileList, isLoading, columns, list, pageData, visible, info } = this.state
    const { getFieldDecorator, getFieldsValue } = this.props.form
    const values  = getFieldsValue()
    let jumpType = values.jumpType || (info && info.jumpType)
    return (
      <div className="push-page">
        {isLoading ? <Spin t1ip="Loading..." className="loading" size='large' /> : ''}
        <PrevImg ref={el => this.PrevImg = el} />
        <Row style={{ paddingBottom: 20 }}>
          <Col lg={{ span: 8 }} style={{ width: 180, marginBottom: 20 }} className="flex-h-a">
            <Button className='creat-station' type="primary" icon="plus" style={{ width: 130 }} onClick={this.add}>添加广告</Button>
          </Col>
          <Col lg={{ span: 8 }} style={{ width: 400, marginBottom: 20 }} className="flex-h-a">
            <span>广告名称：</span>
            <Search style={{ width: 250 }} placeholder="广告名称搜索" onSearch={(e) => this.commonChange(e, 'remark')} enterButton />
          </Col>
          <Col lg={{ span: 8 }} style={{ marginBottom: 20 }} className="flex-h-a">
            <span>显示状态：</span>
            <Select style={{ width: 220 }} defaultValue='' onChange={(e) => this.commonChange(e, 'status')}>
              <Option value=''>全部</Option>
              <Option value={20}>使用中</Option>
              <Option value={10}>等待使用</Option>
              <Option value={30}>已过期</Option>
            </Select>
          </Col>
        </Row>
        {
          !isLoading && (
            <Table
              columns={columns}
              dataSource={list}
              bordered
              rowKey="id"
              pagination={{
                current: pageData.current,
                total: pageData.total,
                pageSize: pageData.pageSize,
              }}
              onChange={this.onPageChange}
            />
          )
        }
        <Modal
          title={info ? '编辑广告' : '添加广告'}
          visible={visible || false}
          onCancel={() => {
            this.setState({
              visible: false,
              upload: false,
              photo: '',
              info: '',
              fileList: [],
            })
          }}
          width={600}
          footer={false}
          destroyOnClose
        >
          <Form className='push-modal-inner' onSubmit={this.handleSubmit} style={{ paddingLeft: 30 }}>
            <Form.Item label="广告名称：" className='flex'>
              {getFieldDecorator('remark', {
                rules: [{
                  required: true,
                  message: '请输入广告名称',
                }],
                initialValue: info ? info.remark : '',
              })(
                <Input placeholder="输入广告名称" style={{ width: 300 }} />
              )}
            </Form.Item>
            <Form.Item label="展示位置" className='flex'>
              {getFieldDecorator('module', {
                rules: [{ required: true, message: '请选择展示位置' }],
                initialValue: info ? info.module : '',
              })(
                <Select placeholder="请选择展示位置" style={{ width: 300, height: 32 }}>
                  <Option value={1}>首页广告轮播</Option>
                  <Option value={2}>生活首页广告轮播</Option>
                  <Option value={3}>新鲜好物广告轮播</Option>
                  <Option value={4}>汽运推荐广告轮播</Option>
                  <Option value={5}>定制旅游广告轮播</Option>
                  <Option value={6}>首页固定广告</Option>
                  <Option value={7}>专题广告轮播</Option>
                  <Option value={8}>汽车票广告轮播</Option>
                  <Option value={9}>汽车票广告固定</Option>
                  <Option value={10}>个人中心广告固定</Option>
                  <Option value={11}>新生免费广告</Option>
                  <Option value={12}>活动弹窗广告</Option>
                  <Option value={13}>启动页广告</Option>
                  <Option value={14}>货运合作广告</Option>
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="跳转类型" className='flex'>
              {getFieldDecorator('jumpType', {
                rules: [{ required: true, message: '请选择跳转类型' }],
                initialValue: info ? info.jumpType : '',
              })(
                <Select placeholder="请选择跳转类型" style={{ width: 300, height: 32 }}>
                  <Option value={1}>链接</Option>
                  <Option value={2}>商品详情</Option>
                  <Option value={3}>旅游详情</Option>
                  <Option value={4}>专题</Option>
                  <Option value={5}>无</Option>
                </Select>,
              )}
            </Form.Item>
            {jumpType === 1 ? <Form.Item label="广告地址：" className='flex'>
              {getFieldDecorator('link', {
                rules: [{
                  required: true,
                  message: '请输入广告地址',
                }],
                initialValue: info ? info.link : '',
              })(
                <TextArea placeholder="输入广告地址" style={{ width: 300, height: 80 }} autosize={false} />
              )}
            </Form.Item> : null
            }
            {jumpType === 2 ? <Form.Item label="商品ID：" className='flex'>
              {getFieldDecorator('link', {
                rules: [{
                  required: true,
                  message: '请输入商品ID',
                }],
                initialValue: info ? info.link : '',
              })(
                <Input placeholder="输入商品ID" style={{ width: 300 }} />
              )}
            </Form.Item> : null
            }
            {jumpType === 3 ? <Form.Item label="线路ID：" className='flex'>
              {getFieldDecorator('link', {
                rules: [{
                  required: true,
                  message: '请输入线路ID',
                }],
                initialValue: info ? info.link : '',
              })(
                <Input placeholder="输入线路ID" style={{ width: 300 }} />
              )}
            </Form.Item> : null
            }
            {jumpType === 4 ? <Form.Item label="专题" className='flex'>
              {getFieldDecorator('link', {
                rules: [{ required: true, message: '请选择专题' }],
                initialValue: info ? info.link : '',
              })(
                <Select placeholder="请选择专题" style={{ width: 300, height: 32 }}>
                  {this.renderGoodTopic()}
                </Select>,
              )}
            </Form.Item> : null
            }
            <Form.Item label="广告有效期：" className='flex'>
              {getFieldDecorator('timer', {
                rules: [{
                  required: true,
                  message: '请选择广告有效期',
                }],
                initialValue: info ? [moment(info.validAt, 'YYYY/MM/DD'), moment(info.expireAt, 'YYYY/MM/DD')] : '',
              })(
                <RangePicker style={{ width: 300 }} />
              )}
            </Form.Item>
            <Form.Item label="广告排序：" className='flex'>
              {getFieldDecorator('position', {
                rules: [{
                  required: true,
                  message: '请选择广告有效期',
                }],
                initialValue: 1,
              })(
                <InputNumber style={{ width: 104 }} />
              )}
              <span> （数字越小越靠前）</span>
            </Form.Item>
            <Form.Item label="广告封面图：" className='flex'>
              {getFieldDecorator('photo', {
                rules: [{
                  required: true,
                  message: '请上传广告封面图',
                }],
                initialValue: info ? info.photo : '',
              })(
                <Upload
                  action=""
                  listType="picture-card"
                  fileList={fileList}
                  onPreview={this.handlePreview}
                  onChange={this.handleChange}
                  beforeUpload={() => { return false }}
                >
                  {fileList.length >= 1 ? null : uploadButton}
                </Upload>
              )}
              <div> （尺寸：750 * 380）</div>
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" size='large' style={{ width: 300, marginLeft: 120, marginTop: 0 }}>保存</Button>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    )
  }
}

export default Advert